import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface FileUploadListProps {
  files: File[];
  showRemove: boolean;
  onChange: (files: File[]) => void;
}

export const FileUploadList = ({
  files,
  showRemove,
  onChange,
}: FileUploadListProps) => (
  <Stack align="start" gap={1} className="w-full pt-4">
    {files.map((file, index) => (
      <Stack
        gap={4}
        key={`${file.name}-${index}`}
        direction="row"
        align="center"
        justify="between"
        className="w-full rounded-md bg-neutral px-3 py-2"
      >
        <Text className="min-w-0 break-all text-subtle">{file.name}</Text>
        {showRemove && (
          <Button
            variant="link"
            size="xs"
            aria-label={`Remove ${file.name}`}
            onClick={(event) => {
              event.stopPropagation();
              onChange(files.filter((_, idx) => idx !== index));
            }}
          >
            Remove
          </Button>
        )}
      </Stack>
    ))}
  </Stack>
);
